import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.25.25A.25.25 0 0 1 8.5.5v10.868l3.318-3.539a.25.25 0 0 1 .364.342l-3.75 4a.25.25 0 0 1-.37-.006l-3.75-4.25a.25.25 0 0 1 .375-.33L8 11.339V.5a.25.25 0 0 1 .25-.25",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.5 11.25a.25.25 0 0 1 .25.25v3.75h11V11.5a.25.25 0 1 1 .5 0v4a.25.25 0 0 1-.25.25H2.5a.25.25 0 0 1-.25-.25v-4a.25.25 0 0 1 .25-.25",
		clipRule: "evenodd"
	})]
});
export default SvgDownload;
